
export const WB_BODY_EXTENSIONS = [
  'activity', 'activity_report', 'section', 'multipanel', 'wb:inline',
];
